import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import {
    FaEye,
    FaEdit,
    FaTrash,
    FaUserTie
} from 'react-icons/fa';
import { useDispatch } from "react-redux";
import { successToast, errorToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
function AllTestimonial() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [testimonialData, setTestimonialData] = useState([
        {
            id: 1,
            name: 'Rohit Sharma',
            designation: 'CEO - Safairo',
            description:
                'Amazing hotel booking service with excellent support and smooth experience.',
            image:
                'https://randomuser.me/api/portraits/men/32.jpg',
            status: 'Active'
        },
        {
            id: 2,
            name: 'Priya Verma',
            designation: 'Travel Blogger',
            description:
                'Best travel platform for luxury stays and affordable pricing.',
            image:
                'https://randomuser.me/api/portraits/women/44.jpg',
            status: 'Active'
        },
        {
            id: 3,
            name: 'Amit Singh',
            designation: 'Business Consultant',
            description:
                'Professional team and user-friendly dashboard experience.',
            image:
                'https://randomuser.me/api/portraits/men/76.jpg',
            status: 'Inactive'
        }
    ]);


    const handleStatusToggle = (id) => {

        const updatedData = testimonialData.map((item) => {

            if (item.id === id) {

                return {
                    ...item,
                    status:
                        item.status === 'Active'
                            ? 'Inactive'
                            : 'Active'
                };

            }

            return item;

        });

        setTestimonialData(updatedData);

    };



    return (
        <div>

            {/* PAGE HEADER */}
            <div className="d-md-flex d-block align-items-center justify-content-between  page-header-breadcrumb">

                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">

                    <nav>

                        <h4 className="fw-semibold">
                            All Testimonials
                        </h4>

                        <ol className="breadcrumb mb-0">

                            <li className="breadcrumb-item">
                                <Link to="/">
                                    Home
                                </Link>
                            </li>

                            <li
                                className="breadcrumb-item active"
                                aria-current="page"
                            >
                                Testimonials
                            </li>

                        </ol>

                    </nav>

                </div>

                <div className="page-title fw-semibold fs-18 mb-0">

                    <button
                       onClick={() => navigate("/add-testimonial")}
                        className="btn btn-primary"
                    >
                        Add Testimonial
                    </button>

                </div>

            </div>

            {/* TABLE */}
            <div className="st-wrapper-card">

                <div className="st-table-responsive">

                    <table className="table st-custom-table align-middle mb-0">

                        <thead>

                            <tr>
                                <th>ID</th>
                                <th>Profile</th>
                                <th>Name</th>
                                <th>Designation</th>
                                <th>Description</th>
                                <th>Status</th>
                                <th>Change Status</th>
                                <th className="text-center">
                                    Action
                                </th>
                            </tr>

                        </thead>

                        <tbody>

                            {
                                testimonialData.map((item) => (

                                    <tr key={item.id}>

                                        <td>
                                            #{item.id}
                                        </td>

                                        {/* PROFILE IMAGE */}
                                        <td>

                                            <img
                                                src={item.image}
                                                alt={item.name}
                                                className="testimonial-profile"
                                                width={40}
                                            />

                                        </td>

                                        <td className="fw-semibold">
                                            {item.name}
                                        </td>

                                        <td>
                                            {item.designation}
                                        </td>

                                        <td className="testimonial-desc">

                                            {item.description}

                                        </td>
<td></td>
                                        <td>

                                            <div className="city-status-switch">

                                                <input
                                                    type="checkbox"
                                                    id={`status-${item.id}`}
                                                    className="city-status-input"
                                                    checked={item.status === 'Active'}
                                                    onChange={() => handleStatusToggle(item.id)}
                                                />

                                                <label
                                                    htmlFor={`status-${item.id}`}
                                                    className="city-status-label"
                                                >

                                                    <span className="city-status-ball"></span>

                                                    <span className="city-status-text">

                                                        {
                                                            item.status === 'Active'
                                                                ? 'Active'
                                                                : 'Inactive'
                                                        }

                                                    </span>

                                                </label>

                                            </div>

                                        </td>

                                        {/* ACTION BUTTONS */}
                                        <td className="text-center d-flex gap-2">

                                            {/* VIEW */}
                                            <button
                                                className="st-action-btn st-view-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "view-testimonial",
                                                            title: "Testimonial Details",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                            >
                                                <FaEye />
                                            </button>

                                            {/* EDIT */}
                                            <button
                                                className="st-action-btn st-edit-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "edit-testimonial",
                                                            title: "Edit Testimonial",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                            >
                                                <FaEdit />
                                            </button>

                                            {/* DELETE */}
                                            <button
                                                className="st-action-btn st-delete-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "delete-testimonial",
                                                            title: "Delete Testimonial",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                            >
                                                <FaTrash />
                                            </button>

                                        </td>

                                    </tr>

                                ))
                            }

                        </tbody>

                    </table>

                </div>

            </div>


        </div>
    );
}

export default AllTestimonial;